import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { brandProtectionServices, sourcingRequestPath, supplyChainServices } from "../content/services";
import { business } from "../content/business";
import { BrandLogo } from "./BrandLogo";

const linkClass = "text-sm leading-6 text-brand-text-muted transition-colors duration-150 hover:text-white focus:outline-none focus-visible:text-white focus-visible:ring-2 focus-visible:ring-brand-lime/70";

export function Footer() {
  return (
    <footer data-track-location="footer" className="border-t border-brand-border bg-[#0d0d0d] pt-16 pb-8">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid gap-12 border-b border-brand-border pb-14 lg:grid-cols-[1.2fr_1fr_0.7fr_0.7fr]">
          <div>
            <Link to="/" aria-label="Nexus Supply Chain home" className="inline-block w-full max-w-[260px]"><BrandLogo variant="lockup" className="h-auto w-full" /></Link>
            <p className="mt-5 max-w-sm text-sm leading-6 text-brand-text-muted">We source products, manage production, check quality, consolidate shipments and arrange international freight from China.</p>
            <Link to={sourcingRequestPath} className="mt-6 inline-flex min-h-11 items-center gap-2 rounded-sm bg-brand-lime px-5 py-2.5 text-sm font-semibold text-brand-dark hover:bg-brand-lime-hover">Start a Sourcing Request<ArrowRight size={15} aria-hidden="true" /></Link>
          </div>

          <div>
            <h2 className="mb-5 font-display text-base font-semibold text-white">Supply Chain</h2>
            <ul className="grid gap-x-5 gap-y-2 sm:grid-cols-2 lg:grid-cols-1">
              {supplyChainServices.map((service) => <li key={service.path}><Link to={service.path} className={linkClass}>{service.name}</Link></li>)}
            </ul>
          </div>

          <div>
            <h2 className="mb-5 font-display text-base font-semibold text-white">Brand Protection</h2>
            <ul className="space-y-2">
              {brandProtectionServices.map((service) => <li key={service.path}><Link to={service.path} className={linkClass}>{service.name}</Link></li>)}
            </ul>
          </div>

          <div>
            <h2 className="mb-5 font-display text-base font-semibold text-white">Company &amp; resources</h2>
            <ul className="space-y-2">
              <li><Link to="/how-nexus-works/" className={linkClass}>How It Works</Link></li>
              <li><Link to="/why-nexus/" className={linkClass}>Why NEXUS</Link></li>
              <li><Link to="/about/" className={linkClass}>About</Link></li>
              <li><Link to="/#faq" className={linkClass}>FAQ</Link></li>
              <li><Link to={sourcingRequestPath} className={linkClass}>Contact</Link></li>
            </ul>
          </div>
        </div>
        <address className="grid gap-4 border-b border-brand-border py-8 not-italic md:grid-cols-[1fr_1.2fr_auto] md:gap-8">
          <div><p className="text-sm font-semibold text-white">{business.legalName}</p><p lang="zh-Hans" className="mt-2 text-sm text-brand-text-muted">{business.chineseName}</p></div>
          <p className="max-w-md text-sm leading-7 text-brand-text-muted">{business.address}</p>
          <a href={business.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-start py-2 text-sm font-semibold text-white underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-4">WhatsApp {business.telephone}</a>
        </address>
        <div className="flex flex-col gap-4 pt-7 text-xs text-brand-text-muted sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Nexus Supply Chain. All rights reserved.</p>
          <div className="flex gap-5"><Link to="/privacy/" className="hover:text-white">Privacy</Link><Link to="/terms/" className="hover:text-white">Terms</Link></div>
        </div>
      </div>
    </footer>
  );
}
